import { render, staticRenderFns } from "./HostingCpanelLaunch.vue?vue&type=template&id=59d50630&"
import script from "./HostingCpanelLaunch.vue?vue&type=script&lang=js&"
export * from "./HostingCpanelLaunch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59d50630')) {
      api.createRecord('59d50630', component.options)
    } else {
      api.reload('59d50630', component.options)
    }
    module.hot.accept("./HostingCpanelLaunch.vue?vue&type=template&id=59d50630&", function () {
      api.rerender('59d50630', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Common/HostingCpanelLaunch.vue"
export default component.exports